exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eMbK0 {\n  height: 340px;\n  overflow: auto;\n  padding: 20px;\n}\n._1Y8Aq {\n  text-align: center;\n  padding: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "eMbK0",
	"button": "_1Y8Aq"
};